module.exports = __webpack_public_path__ + "static/media/city.11621100.svg";